import { PATIENT_HEALTH_EVENT_V1, UserV1 } from '@csp/dmdp-api-user-dto';

const userV1WithMeta = {
  userId: 'p1',
  metas: [
    {
      data: {
        healthEventId: 'e1',
        status: 'NEW',
        timestamp: '2020-06-01T14:12:12+02:00[Europe/Stockholm]',
        healthEventSortOrder: 100,
      },
      name: PATIENT_HEALTH_EVENT_V1,
      type: PATIENT_HEALTH_EVENT_V1,
    },
  ],
} as unknown as UserV1;

const userV1WithoutMeta = {
  userId: 'p1',
  metas: [],
} as unknown as UserV1;

export const PatientHealthEventServiceMock = {
  userV1WithMeta,
  userV1WithoutMeta,
};
